module.exports = __webpack_public_path__ + "static/media/constPicThree.894cc670.jpeg";